import { observer } from 'mobx-react-lite'
import { type JobProgressionViewModel } from '@/features/jobs/details/components/JobProgressionCard/JobProgressionViewModel'
import { WaitingOnAdminProgressionActions } from '@/features/jobs/details/components/JobProgressionCard/WaitingOnAdminProgressionActions'

export interface WaitingOnAdminProgressionActionsContainerProps {
  vm: JobProgressionViewModel
}

export const WaitingOnAdminProgressionActionsContainer = observer(
  function WaitingOnAdminProgressionActionsContainer({
    vm,
  }: WaitingOnAdminProgressionActionsContainerProps) {
    return (
      <WaitingOnAdminProgressionActions
        isOutsourcingExtension={vm.isOutsourcingExtension}
        onResumeFiling={() => vm.answerReadyToFile(true)}
      />
    )
  },
)
